import { User } from '../models/user.models';
import { BaseService } from './base.service';
import { SearchTrainingPayload } from '../models/service.models';

export default class GuardianService extends BaseService {
  public async getGuardians() {
    return this.axios.get(`${this.backendUrl}/guardians`, {});
  }

  public async inviteGuardian(email: string) {
    return this.axios.post(`${this.backendUrl}/guardian-invitations`, { email });
  }

  public async removeGuardian(id: string) {
    return this.axios.delete(`${this.backendUrl}/guardian/${id}`, {});
  }

  public async getPendingGuardianInvitations() {
    return this.axios.get(`${this.backendUrl}/guardian-invitations`, {});
  }

  public async deactivateGuardianInvitation(invitationId: string) {
    return this.axios.delete(`${this.backendUrl}/guardian-invitation/${invitationId}`, {});
  }

  public async acceptGuardianInvitation(invitationId: string) {
    return this.axios.post(`${this.backendUrl}/guardian/guardian-invitation/${invitationId}`, {});
  }

  public async declineGuardianInvitation(invitationId: string) {
    return this.axios.delete(`${this.backendUrl}/guardian/guardian-invitation/${invitationId}`, {});
  }

  public async getAllWardTrainingsForGuardian(payload: SearchTrainingPayload) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    const params = new URLSearchParams({
      start: payload.start,
      end: payload.end,
    }).toString();
    return this.axios.get(`${this.backendUrl}/guardian/trainings?${params}`, {
      headers: {
        'Measurement-System': user.measurementSystem,
      },
    });
  }

  public async getWardTrainingForGuardian(id: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.get(`${this.backendUrl}/guardian/training/${id}`, {
      headers: {
        'Measurement-System': user.measurementSystem,
      },
    });
  }

  public async getWardTeams() {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.get(`${this.backendUrl}/guardian/teams`, {
      headers: {
        'Measurement-System': user.measurementSystem,
      },
    });
  }

  public async getWardTeamDetails(id: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.get(`${this.backendUrl}/guardian/team/${id}`, {
      headers: {
        'Measurement-System': user.measurementSystem,
      },
    });
  }

  public async getWardTeamThreads(id: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.get(`${this.backendUrl}/guardian/team/${id}/threads`, {
      headers: {
        'Measurement-System': user.measurementSystem,
      },
    });
  }

  public async getWardTeamThread(team_id: string, id: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.get(`${this.backendUrl}/guardian/team/${team_id}/thread/${id}`, {
      headers: {
        'Measurement-System': user.measurementSystem,
      },
    });
  }

  public async getWards() {
    return this.axios.get(`${this.backendUrl}/wards`, {});
  }

  public async deleteWard(id: string) {
    return this.axios.delete(`${this.backendUrl}/ward/${id}`, {});
  }
}
